import TableAction from "components/TableAction";
import { useAppContextController } from "context/AppContext";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

const PayrollEditorTableActions = ({
  id,
  row,
  setNavigateUrl,
  isShiftJob,
  isExpanded,
  onToggleSubList,
  onOpenPartnerMembers,
  deductionsOnly,
  onSelectRowForDeductions,
  onSelectRowForTaxDetails,
  editLocked,
  correctionActive,
}) => {
  const { company, userType } = useAppContextController();
  const navigate = useNavigate();

  const navigateLocal = setNavigateUrl ?? navigate;

  const route = row?.slug ? "partners" : "employees";
  const actionroute = row?.slug ? "partners" : "employee";
  const namePrefix = row?.slug ? "Partner" : "Employee";
  const onClickHandler = (action, e) => {
    e.stopPropagation();
    if (action === "employeetoggle") {
      onToggleSubList?.();
      return;
    }
    if (action === "partnersmembers") {
      onOpenPartnerMembers?.(row);
      return;
    }
    if (action === "employeedeductions" || action === "partnersdeductions") {
      onSelectRowForDeductions?.(row);
      return;
    }
    if (action === "employeetaxdetails" || action === "partnerstaxdetails") {
      onSelectRowForTaxDetails?.(row);
      return;
    }
    navigateLocal(`/${route}/${row?.slug ? row?.slug : id}/action/${action}`);
  };

  return (
    <span>
      {!deductionsOnly && (
        <TableAction
          color="info"
          icon="info"
          clickAction={(e) => onClickHandler(`${actionroute}info`, e)}
          tooltip={`${namePrefix} Info`}
        />
      )}
      {!deductionsOnly && !row?.slug && !row?.partnerSlug && (
        <TableAction
          color="success"
          icon="paid"
          clickAction={(e) => onClickHandler(`${actionroute}taxdetails`, e)}
          tooltip="Tax Details"
        />
      )}
      {!(isShiftJob && row?.subRows) &&
        !row?.slug &&
        !editLocked &&
        (!correctionActive || !!row?.rosterData?.isCorrection) && (
          <TableAction
            color="error"
            icon="remove_circle"
            clickAction={(e) => onClickHandler(`${actionroute}deductions`, e)}
            tooltip="Deductions"
          />
        )}
      {!isShiftJob && !deductionsOnly && !!row?.slug && (
        <TableAction
          color="warning"
          icon="diversity_3"
          clickAction={(e) => onClickHandler(`${actionroute}members`, e)}
          tooltip="Members"
          disabled={!row?.slug}
        />
      )}
      {isShiftJob && row?.subRows && !deductionsOnly && (
        <TableAction
          color="dark"
          icon={isExpanded ? "expand_less" : "expand_more"}
          clickAction={(e) => onClickHandler(`${actionroute}toggle`, e)}
          tooltip={isExpanded ? "Collapse List" : "Expand List"}
          disabled={!row?.subRows?.length}
        />
      )}
    </span>
  );
};

export default PayrollEditorTableActions;

PayrollEditorTableActions.defaultProps = {
  id: "",
  setNavigateUrl: () => {},
};

// Typechecking props for the TableAction
PayrollEditorTableActions.propTypes = {
  id: PropTypes.string,
  setNavigateUrl: PropTypes.func,
};
